import React from 'react';
import PropTypes from 'prop-types';
import { IconWithTooltip } from './IconWithTooltip';

export const DeleteIcon = ({ handleClick }) => (
  <IconWithTooltip
    handleClick={handleClick}
    ariaLabel="delete"
    tooltip="Delete"
    icon="trash-alt"
  />
);


DeleteIcon.propTypes = {
// eslint-disable-next-line react/require-default-props
  handleClick: PropTypes.func,
};
